export default {
    label_task:{
        en:"Business Team Requirement",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Business Team Requirement",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Business Team Requirement",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Business Team Requirement",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_crop_id:{
        en:"Crop",
        bn:"কর্মচারী আইডি"
    },
    label_crop_name:{
        en:"Crop",
        bn:"কর্মচারী আইডি"
    },

    label_crop_type2_id:{
        en:"Type",
        bn:"কর্মচারী আইডি"
    },
    label_crop_type2_name:{
        en:"Type",
        bn:"কর্মচারী আইডি"
    },
    label_part_id:{
        en:"Part",
        bn:"কর্মচারী আইডি"
    },
    label_part_name:{
        en:"Part",
        bn:"কর্মচারী আইডি"
    },
    label_area_id:{
        en:"Area",
        bn:"কর্মচারী আইডি"
    },
    label_area_name:{
        en:"Area",
        bn:"কর্মচারী আইডি"
    },
    label_territory_id:{
        en:"Territory",
        bn:"কর্মচারী আইডি"
    },
    label_territory_name:{
        en:"Territory",
        bn:"কর্মচারী আইডি"
    },
    label_market_size:{
        en:"Market Size",
        bn:"কর্মচারী আইডি"
    },
    label_sowing_periods:{
        en:"Sowing Period",
        bn:"কর্মচারী আইডি"
    },
    label_competitor_varieties_ids:{
        en:"Competitors Variety",
        bn:"কর্মচারী আইডি"
    },
    label_reason_sales:{
        en:"Reason for the Sales",
        bn:"কর্মচারী আইডি"
    },

}